import { UserPermissionType } from '../../../../../api/types/user/permissions/user-permission-type';

export const getPermissionsDisplayText = (type: UserPermissionType) => {
  switch (type) {
    case UserPermissionType.ACCOUNTING:
      return 'שכר';
    case UserPermissionType.EDUCATION:
      return 'לימודים';
    case UserPermissionType.FINANCIAL_REPORTS:
      return 'דוחות פיננסים';
    case UserPermissionType.REGISTRATION_AND_COLLECTION:
      return 'גבייה ורישום';
    case UserPermissionType.SETTINGS:
      return 'הגדרות מערכת';
    case UserPermissionType.SETTINGS_BRANCHES:
      return 'הגדרות מערכת (שלוחות)';
  }
};
